import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApplicationService } from '../../../services/application.service';
import { LookupService } from '../../../services/lookup.service';
import { club } from '../../../models/club';
import { saveDrillRequest } from '../../../models/saveDrillRequest';
import { AuthenticationService } from '../../../services/authentication.service';
import { TemplateService } from '../../../services/template.service';
import { assessmentArea } from '../../../models/assessmentArea';
import { AppServices } from '../../../services/appServices';

@Component({
  selector: 'app-create-drill',
  standalone: true,
  imports: [FormsModule, NgFor],
  templateUrl: './create-drill.component.html',
  styleUrl: './create-drill.component.css'
})
export class CreateDrillComponent implements OnInit {
  constructor(private appService:AppServices, private applicationService:ApplicationService, private lookupService:LookupService, private authenticationService:AuthenticationService, private templateService:TemplateService) {}

  @Output() saved = new EventEmitter();
  clubs:club[] = [];
  assessmentAreas:assessmentArea[] = []
  drill:saveDrillRequest = {
    label: '',
    description: '',
    club_id: null,
    username: '',
    is_deleted: false,
    id:null,
    assessment_area: 'FULLSWING'
  };

  ngOnInit(): void {
    let username = this.authenticationService.loggedInUser?.username;
    if(!username) return;
    this.drill.username = username;
    this.getClubs();
    this.assessmentAreas = this.lookupService.getAssessmentAreas();
  }

  async saveDrillClicked() {
    this.applicationService.showGlobalSpinner();
    await this.templateService.saveDrill(this.drill);
    this.saved.emit();
    this.applicationService.hideGlobalSpinner();
  }

  async getClubs() {
    this.clubs = await this.lookupService.searchClubs();
  }

  onClubChange(clubId: number | null): void {
  console.log('selected club id', clubId);

  const selectedClub = this.clubs.find(c => c.id === clubId);

  // call whatever function you need
  this.drill.assessment_area = (selectedClub && selectedClub.id === this.appService.configService.getPutterId()) ? 'PUTTING' : 'FULLSWING';
}
}
